export default "__VITE_ASSET__C44WOp$F__"